import React, { useEffect, useState } from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { loginEmail } from "../../../../Utils/SupabaseServices/UserDatabase";
import { supabase } from "../../../../config/supabaseClient";
import "../Onboarding.css";
import WelcomeConfetti from "../../../../components/Confetti/WelcomeConfetti";
import { useWindowSize } from "react-use";
import Confetti from "react-confetti";

const CompletionStep = (props: any) => {
  // const { username, formData } = props;
  const { username, formData } = {
    username: "test",
    formData: { name: "test", email: "test@test.com", password: "test" },
  };

  const { width, height } = useWindowSize();
  const [showConfetti, setShowConfetti] = useState(true);
  const [countdown, setCountdown] = useState(5);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [loginError, setLoginError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    let timer: NodeJS.Timeout;
    const handleLogin = async () => {
      setIsLoggingIn(true);
      try {
        // Sign out any existing session first
        await supabase.auth.signOut();

        const loginResult = await loginEmail(formData.email, formData.password);
        if (loginResult === "error") {
          setLoginError("Login failed. Please try again.");
          return;
        }
        if (!loginResult) {
          setLoginError("User not found. Please try again.");
          return;
        }

        // Start countdown only after successful login
        timer = setInterval(() => {
          setCountdown((prev) => {
            if (prev <= 1) {
              // Navigate to dashboard with the appropriate state
              navigate(`/dashboard/${loginResult.username}`, {
                state: {
                  is_first_redirect: true, // Always true for onboarding completion
                  is_first_login: false, // Not a first login since it's onboarding
                  from: "onboarding",
                },
              });
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      } catch (error) {
        console.error("Login error:", error);
        setLoginError("An error occurred. Please try again.");
      } finally {
        setIsLoggingIn(false);
      }
    };

    // Start login process immediately
    // handleLogin();

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [navigate, formData]);

  return (
    <div className="instagram-container">
      {showConfetti && (
        <Confetti
          width={width}
          height={height}
          recycle={false}
          numberOfPieces={300}
          gravity={0.15}
          colors={[
            "#22c55e",
            "#4ade80",
            "#86efac",
            "#f472b6",
            "#fb7185",
            "#fcd34d",
          ]}
          tweenDuration={5000}
        />
      )}
      <div className="instagram-card">
        <div className="card-header">
          <div className="instagram-icon-wrapper">
            {/* <AiOutlineCheckCircle className="instagram-icon" style={{ color: '#22c55e' }} /> */}
            <img
              // src={"/assets/NewLogo-removebg.svg"}
              src={"/assets/Logo-White.svg"}
              alt="check"
              className="logo-icon"
              width={40}
              height={40}
            />
          </div>
          {/* <h2 className="card-title">You're All Set!</h2>
          <p className="card-description">
            Welcome, {username}! Your profile is being created now.
            We'll send you an email shortly with next steps.
          </p> */}
        </div>

        {/* <p className="card-description" style={{ textAlign: 'center', marginTop: '16px' }}>
          Thank you for joining! Get ready to elevate your online presence.
        </p> */}

        {username && (
          <WelcomeConfetti username={username} firstName={formData.name} />
        )}

        {/* {loginError ? (
          <p className="card-description" style={{ textAlign: 'center', marginTop: '16px', color: '#ef4444' }}>
            {loginError}
          </p>
        ) : (
          <p className="card-description" style={{ textAlign: 'center', marginTop: '16px', color: '#22c55e' }}>
            {isLoggingIn ? 'Logging you in...' : `You will be redirected to the dashboard in ${countdown} seconds`}
          </p>
        )} */}
      </div>
    </div>
  );
};

export default CompletionStep;
